var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"erro-404-body"},[_c('div',{staticClass:"erro-message"},[_vm._v("\n\t\t\t404 Página não encontrada\n\t\t")])])])
}]

export { render, staticRenderFns }